import styled from '@emotion/styled'
import { Modal } from '@hhgtech/hhg-components/mantine'

export const StyledModal = styled(Modal)`
  .mantine-Modal-body {
    padding: 16px;
  }
  .share-icon {
    svg {
      width: 100%;
      height: 100%;
    }
    flex-shrink: 0;
  }

  .input-share {
    min-width: unset;
    height: fit-content;
    min-height: unset;
    input {
      background: white;
    }
  }
`
